import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { useTranslation } from 'react-i18next';
import ProductCard from '../components/common/ProductCard';
import { Helmet } from 'react-helmet-async';
import SEO from '../components/common/SEO';

const Wishlist = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language?.startsWith('ar');
    const { wishlistItems } = useWishlist();

    if (wishlistItems.length === 0) {
        return (
            <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center animate-fade-in">
                <div className="w-24 h-24 mb-6 rounded-full bg-gray-50 flex items-center justify-center text-4xl text-gray-200">
                    <i className="far fa-heart"></i>
                </div>
                <h2 className="text-3xl font-black text-gray-900 mb-4">{t('wishlist.empty', 'Your wishlist is empty')}</h2>
                <p className="text-gray-500 mb-8 max-w-md">{t('wishlist.empty_desc', 'Save items you love and they will appear here. It\'s the perfect way to keep track of your favorites.')}</p>
                <Link to="/shop" className="bg-brand-primary text-white px-10 py-4 rounded-2xl font-black text-sm uppercase tracking-widest shadow-xl shadow-brand-primary/20 hover:scale-105 active:scale-95 transition-all">
                    {t('wishlist.browse_shop', 'Browse Collection')}
                </Link>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <html lang={isArabic ? 'ar' : 'en'} dir={isArabic ? 'rtl' : 'ltr'} />
            </Helmet>
            <SEO />
            <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 lg:py-20 animate-fade-in">
                <div className="flex items-center justify-between mb-12 pb-6 border-b border-gray-100">
                    <div>
                        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-2">{t('wishlist.title', 'My Wishlist')}</h1>
                        <p className="text-gray-400 text-xs font-bold uppercase tracking-widest">{t('wishlist.count', { count: wishlistItems.length })} {t('wishlist.saved_items', 'Saved Items')}</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                    {wishlistItems.map((item) => (
                        <ProductCard
                            key={item.id || item.product_id}
                            product={item}
                            isArabic={isArabic}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default Wishlist;
